interface SpeakingIndicatorProps {
  bars?: number[]
}

export const SpeakingIndicator = ({ bars }: SpeakingIndicatorProps) => {
  const multipliers = [6, 12, 16, 12, 6]
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '2px',
      }}
    >
      {bars?.map((bar, i) => {
        const clampedBar = Math.min(Math.max(bar ?? 0, 0), 1)
        const height = clampedBar * (multipliers[i % multipliers.length] ?? 1)
        return (
          <div
            key={i}
            className="transition-all bg-f1-foreground-accent"
            style={{
              width: '2px',
              height: `${height}px`,
              backgroundColor: '#07A2AD',
              borderRadius: '4px',
            }}
          />
        )
      })}
    </div>
  )
}
